import React from 'react';
import MarketingLayout from '../components/marketing/MarketingLayout';
import PageHero from '../components/marketing/PageHero';
import { IMAGES } from '../lib/marketingImages';
import { CONTACT_EMAIL } from '../config';

export default function TermsPage() {
  return (
    <MarketingLayout>
      <PageHero image={IMAGES.heroPower} eyebrow="Legal" title="Terms of service" subtitle="The simple rules for using SmartPay as a household customer." />
      <article className="max-w-3xl mx-auto px-4 py-16 space-y-6 text-muted-foreground">
        <p>By creating an account you agree to use SmartPay to pay legitimate utility and household bills in your name or on behalf of people who asked you to help.</p>
        <p>You are responsible for entering the correct meter or account number. Tokens and confirmations are issued by the underlying provider once payment succeeds.</p>
        <p>Do not share your PIN. We will never ask for it by email or WhatsApp.</p>
        <p>Questions: <a className="text-primary font-medium" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
        <p>Last updated August 2026.</p>
      </article>
    </MarketingLayout>
  );
}
